<template>
    <div>
        <div class="row animated fadeInRightBig">
            <div class="col-md-12">
                <div class="ibox">
                    <div class="ibox-title">
                        <h5>Planejamento</h5>
                    </div>
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-3">
                                <p style="padding-top: 17px; margin: 0 0 5px">
                                    Templates de Check-List
                                </p>


                                <p class="text-center" style="margin: 11px 0">
                                    Arraste o
                                    <b>Template</b> para o <b>dia</b> desejado
                                </p>

                                <hr />

                                <div class="input-group" style="margin-bottom: 15px">
                                    <input type="text" v-model="templateSearchBar" class="form-control"
                                        placeholder="Procurar Assunto" aria-describedby="basic-addon2" />
                                    <span class="input-group-addon" id="basic-addon2">
                                        <i class="glyphicon glyphicon-search"></i>
                                    </span>
                                </div>


                                <div class="widget yellow-bg p-xs text-center"
                                    v-show="templates.length === 0 && loadTemplate === true">
                                    <i class="fa fa-warning fa-2x"></i>
                                    <h3 class="font-bold no-margins">Templates não encontrados!</h3>
                                </div>
                                <div id="external-events" class="scrollBar"
                                    v-show="templates.length > 0 && loadTemplate === true">
                                    <div v-if="filter_selected.template_checklist_id == ''">

                                        <div v-for="(template, index) in templates" :key="index + timeNow" class="
                            external-event
                            navy-bg
                            ui-draggable ui-draggable-handle
                          " :data-event="JSON.stringify(template)" :style="{
                            position: 'relative',
                            // 'display': 'inline-block',

                        }">
                                            {{ template.name }}
                                        </div>

                                    </div>
                                    <div v-else>
                                        <div v-for="(template, index) in filteredTemplates" :key="index + timeNow"
                                            class="external-event navy-bg ui-draggable ui-draggable-handle"
                                            :data-event="JSON.stringify(template)" :style="{
                                                position: 'relative',
                                            }">
                                            {{ template.name }}
                                        </div>
                                    </div>
                                </div>

                                <hr style="margin-bottom: 0; margin-top: 12px" />


                            </div>
                            <div class="col-md-9 m-t-sm" @click="checkIfMonthChanged">
                                <full-calendar ref="calendar" @event-receive="eventReceive" @event-selected="eventClick"
                                    :saveEvent="saveEvent" :config="config" :events="events"></full-calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="modal-filter" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content animated fadeIn">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">×</span>
                            <span class="sr-only">Close</span>
                        </button>
                        <h4 class="modal-title">Filtros</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6 form-group">
                                <label>Data de Cadastro - Inicial</label>
                                <input type="date" class="form-control" v-model="filters.whereBetween.created_at[0]" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Data de Cadastro - Final</label>
                                <input type="date" name id class="form-control"
                                    v-model="filters.whereBetween.created_at[1]" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-dismiss="modal">
                            <i class="fa fa-close"></i> Fechar
                        </button>
                        <button type="button" class="btn btn-primary" @click="getTemplates" data-dismiss="modal">
                            <i class="fa fa-check"></i> Aplicar Filtros
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <detail-modal @deleteEvents="deleteEvents" :enableDelete="enableDelete" :selectedEvent="selectedEvent"
            :selectedEvents="selectedEvents" :themes="themes"></detail-modal>

        <event-config-modal :newEvent="newEvent" :selectedTemplate="selectedTemplate">
        </event-config-modal>

    </div>
</template>

<script>
import { FullCalendar } from "vue-full-calendar";
import DetailModal from "./DetailModal";
import EventConfigModal from "./EventConfigModal.vue";

import { store } from "../../main.js";

import CalendarEvent from "./CalendarEvent";

import Vue from "vue";
const Constructor = Vue.extend(CalendarEvent);

export default {
    data: function () {
        return {
            retorno: [],
            selectedTemplate: {},
            calendarMonth: '',
            calendarYear: '',
            newEvent: '',
            templateSearchBar: "",
            filters: {
                paginated: false,
                special: "",
                template_checklist_id: "",
                orderByDesc: "updated_at",
                whereBetween: {
                    created_at: ["", ""],
                },
            },
            enableDelete: true,
            templates: [],
            themes: [],
            filter_selected: {
                template_checklist_id: "",
            },
            loadTemplate: false,
            events: [],
            special: false,
            config: {
                eventRender(event, element) {
                    const vm = new Constructor({
                        propsData: {
                            event
                        }
                    }).$mount();

                    element.html(vm.$el);
                },
                selectConstraint: {
                    start: new Date().toISOString().split('T')[0],
                    end: (() => {
                        const startDate = new Date();
                        const endDate = new Date(startDate);
                        endDate.setMonth(endDate.getMonth() + 6);
                        return endDate.toISOString().split('T')[0];

                    })(),
                },
                eventConstraint: {
                    start: new Date().toISOString().split('T')[0],
                    end: (() => {
                        const startDate = new Date();
                        const endDate = new Date(startDate);
                        endDate.setMonth(endDate.getMonth() + 6);
                        return endDate.toISOString().split('T')[0];
                    })(),
                },
                locale: "pt-BR",
                timezone: "UTC",
                defaultView: "month",
                header: {
                    left: "title",
                    center: "",
                    right: "today prev,next",
                },
                buttonText: {
                    today: "Hoje",
                },
                displayEventTime: false,
                eventDrop: function (event, delta, revertFunc) {
                    let url = store.getters.api;
                    url = url + "events/" + event.id;

                    axios.defaults.headers.common["authorization"] =
                        "Bearer " + localStorage.getItem("token");

                    axios
                        .put(url, {
                            dds_date: event.start.format("YYYY-MM-DD") + " 00:00:00",
                        })
                        .catch((e) => console.log(e));
                },
                editable: true,
                selectable: true,
                droppable: true,
            },
            selected: {},
            selectedEvents: [
                {
                    team: {
                        name: "",
                    },
                    shift: {
                        name: "",
                    },
                    theme: {
                        title: "",
                    },
                },
            ],
            selectedEvent: {},
        };
    },
    methods: {
     
        checkIfMonthChanged() {
            if (this.calendarMonth != this.$refs.calendar.$el.innerText.split(' ')[0] || this.calendarYear != this.$refs.calendar.$el.innerText.split(' ')[1].substring(0, 4)) {
                this.events = [];
                this.calendarMonth = this.$refs.calendar.$el.innerText.split(' ')[0];
                this.calendarYear = this.$refs.calendar.$el.innerText.split(' ')[1].substring(0, 4);
                this.getEvents();
            }
        },
        timeNow() {
            let date = new Date();
            return date.getTime();
        },
        filter: function () {
            this.getTemplates();
            $("#modal-filter").modal("hide");
        },
        deleteEvents() {
            this.getEvents();
        },
        eventClick: function (event, jsEvent, view) {
            const self = this;

            console.log(event);
            const api = self.$store.getters.api + "checklists-execution-by-id/" + event.id;
            self.$http
                .get(api)
                .then((response) => {
                    console.log(response.data);
                    self.selectedEvents = response.data;            
                })
                .then(() => {
                    $("#detailModal").modal("show");
                });
        },
        getTemplates() {
            const self = this;
            const api =
                self.$store.state.api +
                "checklists?paginated=false&orderByAsc=name";

            self.$http
                .get(api)
                .then((response) => {
                    self.templates = response.data.data;
                })
                .then(() => {
                    self.loadTemplate = true;
                })
                .catch((error) => {
                    self.$error("Ocorreu um erro ao buscar as informações");
                });
        },
        initdrag() {
            const self = this;
            $("#external-events div.external-event").each(function () {
                $(this).draggable({
                    zIndex: 90000,
                    revert: true, // will cause the event to go back to its
                    revertDuration: 0, //  original position after the drag
                    revert: "invalid",
                    cursor: "move",
                    helper: "clone",
                    appendTo: "body",
                    containment: "window",
                    scroll: true,
                });
            });
        },

        getEventsByFilter() {
            function getCalendarEvents(filter) {
                var events = new Array();
                if (filter == null) {
                    events = calendar.fullCalendar("getTemplates");
                } else {
                    events = getEventsByFilter(filter);
                }
                return events;
            }
        },
        getEvents() {
            const self = this;
            const api = self.$store.state.api + "checklists-execution";

            var innerText = this.$refs.calendar.$el.innerText.split(' ');
            this.calendarMonth = innerText[0];
            this.calendarYear = innerText[1].substring(0, 4);

            self.$http
                .get(api, {
                    params: {
                        paginated: false,
                        month: this.calendarMonth,
                        year: this.calendarYear,
                    },
                })
                .then((response) => {
                    self.events = response.data.data;
                })
                .catch((error) => {
                    self.$error("Ocorreu um erro ao buscar as informações");
                });
        },
        generate: function (error) {
            const self = this;
            // const api = self.$store.state.api + "events/plan/generate";

            // self.$http
            //     .post(api)
            //     .then((response) => {
            //         if (!error) {
            //             self.$message(null, "Programação gerada com sucesso", "success");
            //         }
            //         self.getEvents();
            //     })
            //     .catch((error) => {
            //         self.$error("Não foi possível gerar a programação");
            //     });
        },
        eventReceive(event) {
            this.newEvent = event;

            const self = this;
            const api = self.$store.state.api + "themes/" + this.newEvent.id + "?with[]=teams"

            console.log(this.newEvent);

            self.selectedTemplate = this.newEvent
            $("#EventConfigModal").modal("show");
            // self.$http
            //   .get(api)
            //   .then((response) => {
            //     self.selectedTemplate = response.data.data[0].teams;
            //     $("#EventConfigModal").modal("show");
            //   })
            //   .catch((error) => {
            //     self.$message(
            //       null,
            //       "Ocorreu um erro ao buscar as informações",
            //       "error"
            //     );
            //   });

        },
        saveEvent(template_id, date_event, status, event_time, teams, selectTeams, branches, selectBranches) {
            const self = this;
            const api = self.$store.state.api + "checklists-execution";
            let event = {
                execution_date: date_event + ' ' + event_time,
                status_id: status,
                checklist_id: template_id,        
                teams: teams,
                selectTeams: selectTeams,
                branches,
                selectBranches
            }
            self.$http
                .post(api, event)
                .then((response) => {
                    self.generate(false);
                })
                .catch((error) => {
                    self.generate(true);
                    self.$error("Ocorreu um erro ao salvar o evento! Verifique se existem usuários nas unidades e áreas selecionadas.", { timeout: 10000 });
                });
        },
        updateEventsTheme: function (dds_date, theme_id) {
            const self = this;
            const api =
                self.$store.state.api + "events/" + dds_date + "/update-theme";

            self.$http
                .put(api, {
                    theme_id: theme_id,
                })
                .then((response) => {
                    self.getEvents();
                    self.$message(
                        null,
                        "O tema dos eventos foi atualizado com sucesso",
                        "success"
                    );
                })
                .catch((error) => {
                    self.$error("Não foi possível atualizar o tema");
                });
        },
        prepareThemeUrl: function () {
            let filters = "?paginated=false&with[]=theme_category&";
            this.filters.special = this.special ? 1 : 0;
            this.filters.template_checklist_id = this.filter_selected.template_checklist_id;
            $.each(this.filters, function (key, value) {
                if (key == "template_checklist_id" && value == "") {
                    return;
                }
                if (typeof value === "object") {
                    $.each(value, function (key2, value2) {
                        if (value2[0] && value2[1]) {
                            filters += key + "[" + key2 + "][]=" + value2[0] + "&";
                            filters += key + "[" + key2 + "][]=" + value2[1];
                        }
                    });
                } else {
                    filters += key + "=" + value + "&";
                }
            });
            return filters;
        },
    },
    updated() {
        const self = this;
        self.initdrag();
    },
    computed: {
        filteredTemplates() {
            const searchTerm = this.templateSearchBar.toLowerCase();
            return this.retorno.filter(template => {
                // Faça aqui a lógica de filtragem com base no searchTerm
                // Por exemplo, você pode verificar se o título do tema inclui o searchTerm
                return template.title.toLowerCase().includes(searchTerm);
            });
        },
        templateFiltered: function () {

            return this.templates;

        },

    },
    components: {
        CalendarEvent,
        FullCalendar,
        DetailModal,
        EventConfigModal,
    },
    mounted() {
        this.getTemplates();
        this.getEvents();
    },
};
</script>

<style>
.ibox-tools a {
    cursor: pointer;
    margin-left: 5px;
    color: #676a6c;
}

.fc-event,
.fc-agenda .fc-event-time,
.fc-event a {
    padding: 4px 6px;
}

select.input-lg,
.input-group-lg>select.form-control,
.input-group-lg>select.input-group-addon,
.input-group-lg>.input-group-btn>select.btn {
    height: 44px;
    line-height: 44px;
}

.scrollBar {
    overflow-y: scroll;
    height: 200px;
    width: 100%;
    overflow-x: hidden;
}

.bg-orange {
    background-color: #f17436 !important;
    color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/CheckList/Plan.vue